import { useEffect, useState } from 'react';
import { useDebounce } from 'use-debounce';
import { Search as SearchIcon } from 'lucide-react';
import { Input } from '../../ui/Input/Input';
import { useTranslation } from 'react-i18next';
import { useSearch } from '@hero/hooks-shared';
export interface SearchInputProps {
  term: string;
  setTerm: (value: string) => void;
  placeholder?: string;
  /** Debounce delay in ms before calling setTerm. Default 300. */
  debounceMs?: number;
  /** Optional className for the wrapper. */
  className?: string;
}

/**
 * Shared search input with internal debounce.
 * Flat props: term, setTerm, placeholder. Used in core tables and elsewhere.
 */
export function SearchInput({
  term,
  setTerm,
  placeholder: placeholderProp,
  debounceMs,
  className,
}: SearchInputProps) {
  const { t, i18n } = useTranslation(['c-main']);
  const isRTL = i18n.language === 'ar';

  const searchHook = useSearch({
    delay: debounceMs,
    searchValue: term,
    onSearchReadyChange: setTerm,
  });

  const placeholder = placeholderProp ?? t('search.placeholder');

  return (
    <div className={className ?? 'relative w-full max-w-[350px]'}>
      <SearchIcon
        className={`absolute top-2.5 h-5 w-5 text-muted-foreground ${isRTL ? 'right-2' : 'left-2'}`}
      />
      <Input
        placeholder={placeholder}
        value={searchHook.inputSearch}
        onChange={searchHook.onInputSearchChange}
        className={`${
          isRTL ? 'pr-9' : 'pl-9'
        } w-full bg-transparent border-none outline-none focus:outline-none focus:ring-0 focus:border-none`}
        dir={isRTL ? 'rtl' : 'ltr'}
      />
    </div>
  );
}
